import React from 'react';
import { useTranslation } from '@wix/fe-essentials-standalone';
import MarketplaceLogo from '../../Images/MarketplaceLogo';
import { LOGO_HEIGHT, LOGO_WIDTH } from '../utils/constants';
import useMarketplaceHeaderBi, {
  BI_CLICK_TYPES,
  IMPHeaderPageName,
} from '@components/Hooks/useMarketplaceHeaderBi';
import WixStudioSvg from '@components/Images/WixAgencyProfileLogo/WixStudioSvg';
import s from './FormattedMarketplaceLogo.module.scss';

export const LogoTypes = {
  studio: 'studio',
  marketplace: 'marketplace',
} as const;

type LogoTypes = keyof typeof LogoTypes;

const FormattedMarketplaceLogo = ({
  isInternal,
  pageName,
  logoType = 'marketplace',
}: {
  isInternal: boolean;
  pageName: IMPHeaderPageName;
  logoType?: LogoTypes;
}) => {
  const { reportClick } = useMarketplaceHeaderBi({ pageName });
  const { t } = useTranslation();

  const showStudioLogo = logoType === LogoTypes.studio;
  const logoLink = showStudioLogo
    ? 'https://www.wix.com/studio'
    : 'https://www.wix.com/marketplace';

  return (
    <li className={`${s.cell} ${isInternal ? s.internal : ''}`}>
      <a
        href={logoLink}
        aria-label={t('marketplace-header-logo-link-aria-label')}
        data-hook="logo-link"
        onClick={() => {
          reportClick({
            clickType: BI_CLICK_TYPES.wixMarketplace,
          });
        }}
        style={{ height: `${LOGO_HEIGHT}px`, alignContent: 'center' }}
      >
        {showStudioLogo ? (
          <WixStudioSvg />
        ) : (
          <MarketplaceLogo width={LOGO_WIDTH} height={LOGO_HEIGHT} />
        )}
      </a>
      {isInternal && <h5 className={s.internal}>&nbsp;/ INTERNAL</h5>}
    </li>
  );
};

export default FormattedMarketplaceLogo;
